<script setup>
defineProps({
  newsSlug: {
    type: Object,
    required: true,
  },
  newsTitle: {
    type: String,
    required: true,
  },
});
</script>

<template>
  <NuxtLink :to="newsSlug" class="highlight">
    <div class="highlight__wrapper">{{ newsTitle }}</div>
  </NuxtLink>
</template>

<style lang="postcss" scoped>
.highlight {
  display: block;

  &__wrapper {
    font-family: var(--title-font-family);
    color: #fff6fb;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 22px;
    border-radius: 16px;
    padding: 16px;
    text-align: center;
    background: linear-gradient(
      95deg,
      rgba(255, 0, 0, 60%) 0%,
      rgba(255, 0, 0, 42%) 100%
    );

    @media (max-width: 960px) {
      max-width: none;
      width: 100%;
      margin: 0;
    }
  }
}
</style>
